export default {
  functionKey: "ARRONDI",
  title: "ARRONDI",
  group: "Calcul",
  origin: [],
  target: [],
  description: "Arrondi un nombre",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const jsCode = `${destination} = Math.round(${origin});`;
    const safeCode = `
    if (!isNaN(parseInt(${origin}))) {
      ${jsCode}
    } else {
      ${destination} = '';
    }`;
    return { displayCode: jsCode, safeCode };
  }
}
